import React, {useEffect, useState} from 'react';
import {UpdateActiveStep} from "../../../../redux/actions/tourActions";
import {STEPS} from "../../helpers";
import MeetingsConfigurationStep from "../MeetingsConfigurationStep/MeetingsConfigurationStep";
import {openActiveMenuService, SetIsFullWidth} from "../../../../redux/actions";
import ManageYourDataStep from "../ManageYourDataStep/ManageYourDataStep";
import {useDispatch, useSelector} from "react-redux";
import {Tour} from "antd";
import {useTranslation} from "react-i18next";
import {useTourActions} from "../../hooks";
import {ApiStatus} from "../../../../utils/constants";
import AiMeetingReviewStep from "../AllYourVideosHub/AllYourVideosHub";
import CreateChainsWithinChannels from "../CreateChainsWithinChannels/CreateChainsWithinChannels";

const TourTwoStep = () => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const channels = useSelector(state => state.channels?.channels || []);
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const {handleClickNextStep2} = useTourActions();
    const [step, setStep] = useState(0);
    const isFetchingVideos = useSelector(state => state.videos.isFetchingVideos);
    console.log('isFetchingVideos',isFetchingVideos)
    useEffect(() => {
        setTimeout(() => {
            if ([STEPS.TWO].includes(activeStep)) {
                setTimeout(()=>{
                    if (isFetchingVideos === ApiStatus.SUCCESS) {
                        const element = document.getElementById(`channel-id__${channels?.[1]?.id}`);
                        if (element) {
                            element.scrollIntoView({behavior: 'smooth', block: 'start'});
                        }
                        setTimeout(() => {
                            setIsOpen(true)
                        }, 1000)
                    }
                },1000)
            } else {
                setIsOpen(false)
            }
        }, 500)
    }, [activeStep, isFetchingVideos]);

    useEffect(() => {
        return () => {
            dispatch(UpdateActiveStep(null));
            setIsOpen(false)
        }
    }, [])

    const steps = [
        {
            title: t('tour_step_2'),
            description: <AiMeetingReviewStep/>,
            target: () => document.getElementById(`channel-id__${channels?.[1]?.id}`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: ()=> {
                        setStep(1)
                }
            },
            placement: 'bottom'
        },
        {
            title: t('tour_step_2_1'),
            description: <CreateChainsWithinChannels/>,
            target: () => document.getElementById(`tour-two-step-chains-count-${channels?.[1]?.id}`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => {
                        window.scrollTo({
                            top: 0,
                            // behavior: 'smooth'
                        })
                    setTimeout(()=>{
                        setStep(2)
                    },100)
                }
            },
            placement: 'bottom'
        },
        {
            title: t('tour_step_2_2'),
            description: <MeetingsConfigurationStep/>,
            target: () => document.querySelector(`.calendar`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => {
                    dispatch(SetIsFullWidth(true));
                    dispatch(openActiveMenuService('4'))
                    setTimeout(()=>{
                        setStep(3)
                    },500)
                }
            },
            placement: 'left'
        },
        {
            title: t('tour_step_2_3'),
            description: <ManageYourDataStep/>,
            target: () => document.getElementById(`menu-item-4`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => {
                    handleClickNextStep2();
                }
            },
            placement: 'left'
        }
    ];

    return (
        <Tour
            indicatorsRender={(current, total) => (
                <span>
                      {current + 1} / {total}
                     </span>
            )}
            placement="left"
            open={isOpen}
            onClose={() => {
                dispatch(UpdateActiveStep(null));
                setIsOpen(false)
                setStep(0);
            }}
            current={step}
            steps={steps}
            gap={{radius: 12, offset: 4 }}
        />
    );
};

export default TourTwoStep;